// extracted by mini-css-extract-plugin
export default {"filename":"upload_filename__laTGN","element":"upload_element__fxP6Q","audio":"upload_audio__pk2L8"};